import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { EventForm } from '../components/events/EventForm';

export default function EventNew() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);

  const submit = async (data) => {
    setSaving(true);
    try {
      const res = await api.post('/events', data);
      toast.success('Event created!');
      navigate(`/app/events/${res.data.id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not create event');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="event-new-page">
      <Button variant="ghost" onClick={() => navigate('/app/events')} className="gap-2 mb-4 -ml-2">
        <ArrowLeft className="h-4 w-4" /> Back to events
      </Button>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight mb-6">Create event</h1>
      <EventForm
        initial={{ host: user?.name || '' }}
        onSubmit={submit}
        submitLabel="Create event & open flyer"
        submitting={saving}
      />
    </div>
  );
}
